<ng-container [ngSwitch]="cta$ | async">
  <div>
    <button
      *ngSwitchCase="'Sign Up'"
      data-test="collection-join-now-button"
      floAnalytics
      tagName="Button"
      name="Collection Sign Up Click"
      (click)="joinNow()"
      class="btn btn-primary"
      [class]="classes"
      >Sign Up
    </button>
    <button
      *ngSwitchCase="'Resume'"
      data-test="collection-resume-button"
      floAnalytics
      tagName="Button"
      name="Collection Resume Click"
      (click)="resumeSubscription()"
      class="btn btn-primary"
      [class]="classes"
      >Resume
    </button>
    <button
      *ngSwitchCase="'Favorite'"
      data-test="collection-favorite-button"
      floAnalytics
      tagName="Button"
      name="Collection Favorite Click"
      (click)="favorite()"
      class="btn btn-secondary"
      [class]="classes"
    >
      <span
        floSvg="icon-star-outlined"
        aria-hidden="true"
        class="svg-icon-lg svg-vertical-align-text-bottom me-1"
      ></span
      >Favorite</button
    >
    <button
      *ngSwitchCase="'Favorited'"
      data-test="collection-unfavorite-button"
      floAnalytics
      tagName="Button"
      name="Collection Unfavorite Click"
      (click)="unfavorite()"
      class="btn btn-primary"
      [class]="classes"
      ><span
        floSvg="icon-star-filled"
        aria-hidden="true"
        class="svg-icon-lg svg-vertical-align-text-bottom me-1"
      ></span
      >Favorited</button
    >
  </div>
</ng-container>
